export default __webpack_public_path__ + "static/media/bg2.92fbf814.jpeg";